<button
  mat-icon-button
  matTooltip="Font weight"
  (click)="fontWeightChanged.emit(fontWeight === FontWeight.Bold ? FontWeight.Normal : FontWeight.Bold)"
  [intercomTarget]="'toolbar-context-menu-font-weight'"
>
  <fa-icon [icon]="fontWeight === 'bold' ? ['fal', 'bold'] : ['fas', 'bold']"></fa-icon>
</button>
